export default __webpack_public_path__ + "static/media/ML_Logo.461b80c6.png";